
// import loadComponentArticle from './infiniteScrooll';

// Tambahkan event listener untuk complete.te.infiniteScroll
// window.addEventListener('complete.te.infiniteScroll', () => {
//     // Panggil loadComponentArticle saat complete.te.infiniteScroll terpicu
//     loadComponentArticle(currentUrl + '/infinite');

// });


//top Article
fetch(currentUrl + '/trending')
    .then(response => response.text())
    .then(html => {
        document.querySelector('#sideBar').insertAdjacentHTML('beforeend', html);
    });
